// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"backdrop_backdrop__O11Tw","isConfirm":"backdrop_isConfirm__3-jsL"};